

import request from './request';


//发布商机-产品类别
export function business_publish_product_cate(params) {
    return request({
        url: 'business_publish/product_cate',
        method: 'get',
        params
    })
}
//商机列表
export function business_publish_lists(params) {
    return request({
        url: 'need/lists',
        method: 'get',
        params
    })
}
//商机详情
export function business_publish_detail(params) {
    return request({
        url: 'need/detail',
        method: 'get',
        params
    })
}
//应答列表
export function business_reply_lists(params) {
    return request({
        url: 'business_reply/lists',
        method: 'get',
        params
    })
}
//商机发布
export function business_publish_add(data) {
    return request({
        url: 'need/publish',
        method: 'post',
        data
    })
}
// 获取需求标签
export function getNeedLabel() {
    return request({
        url: 'need/getNeedLabel',
        method: 'get'
    })
}
// 获取机构类型
export function getOrganizationLabel() {
    return request({
        url: 'need/getOrganizationLabel',
        method: 'get'
    })
}

//商机删除
export function business_publish_delete(data) {
    return request({
        url: 'business_publish/delete',
        method: 'delete',
        data
    })
}
// 应答
export function business_reply_add(data) {
    return request({
        url: `need_reply/needReply`,
        method: 'post',
        data
    })
}


